export enum QueryKeys {
  Voices = 'voices',
  MediaFileUrl = 'media-file-url',
  MediaFolderContent = 'media-folder-content',
  SoundDesigns = 'sound-designs',
  SoundEffects = 'sound-effects',
}
